import React               from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Product }         from "./product"

export const Products = ({ workorderState, setWorkorderState }) => {  
  const products = workorderState.invoiceLines || []

  const handleProductChange = (index, quantity) => {
    const copiedProducts = [...products]
    copiedProducts[index] = {
      ...copiedProducts[index],
      quantity
    }
    setWorkorderState({ invoiceLines: copiedProducts })
  }

  const updateProduct = (index, newId, name) => {
    const copiedProducts = [...products]
    copiedProducts[index] = {
      ...copiedProducts[index],
      productId: newId,
      mbcLineId: null,
      name
    }

    setWorkorderState({ invoiceLines: copiedProducts })
  }

  const updateBpuLine = (index, bpuLine) => {
    const copiedProducts = [...products]
    if (!bpuLine) {
      copiedProducts[index] = {
        ...copiedProducts[index],
        mbcLineId: null,
        name:      ""
      }
    } else {
      copiedProducts[index] = {
        ...copiedProducts[index],
        mbcLineId: bpuLine.id,
        productId: null,
        name:      `${bpuLine.code} — ${bpuLine.label}`
      }
    }
    setWorkorderState({ invoiceLines: copiedProducts })
  }

  const addProduct = () => {
    const newProducts = [...products, { productId: null, mbcLineId: null, quantity: "", name: "" }]
    setWorkorderState({ invoiceLines: newProducts })
  }

  const addBpuLine = () => {
    const newProducts = [...products, { productId: null, mbcLineId: null, quantity: "", name: "", _kind: "bpu" }]
    setWorkorderState({ invoiceLines: newProducts })
  }

  const addOffBpuLine = () => {
    const newProducts = [...products, { productId: null, mbcLineId: null, quantity: "", name: "", _kind: "off_bpu" }]
    setWorkorderState({ invoiceLines: newProducts })
  }

  const removeProduct = index => {
    const copiedProducts = [...products]
    copiedProducts.splice(index, 1)
    setWorkorderState({ invoiceLines: copiedProducts })
  }
   
  return (
    <>
      <div className ="cocoon-grid mb-2">
        <div className ="cocoon-grid__header">
          <label>{ I18n.t("products.product") }</label>
          <label className ="g-c-span-2">{ I18n.t("interventions.quantity") }</label>
        </div>
      </div>
      {
        products.map((product, index) => {
          // BPU ids used by *other* lines — exclude them from this line's picker
          // so the same article can't be picked twice on the same workorder.
          const usedBpuIds = products
            .filter((_, i) => i !== index)
            .map(p => p.mbcLineId)
            .filter(Boolean)

          return (
            <Product
              key             = { index }
              index           = { index }
              product         = { product }
              technician      = { workorderState.technicianId }
              mbcContractId   = { workorderState.mbcContractId }
              mbcAllowOffBpu  = { workorderState.mbcAllowOffBpu }
              usedBpuIds      = { usedBpuIds }
              onChange        = { handleProductChange }
              updateProduct   = { updateProduct }
              updateBpuLine   = { updateBpuLine }
              removeProduct   = { removeProduct }
            />
          )
        })
      }

      { workorderState.mbcContractId
        ? <div className="d-flex flex-column a-i-end">
            <a className='small text-pointer' onClick={ addBpuLine }>
              <FontAwesomeIcon icon='plus-circle' className="mr-2"/>
              { I18n.t("mbc_contracts.workorders.add_bpu_article", { defaultValue: "Ajouter un article BPU" }) }
            </a>
            <a className='small text-pointer mt-1' onClick={ addOffBpuLine }>
              <FontAwesomeIcon icon='plus-circle' className="mr-2"/>
              { I18n.t("mbc_contracts.workorders.add_off_bpu_article", { defaultValue: "Ajouter un article hors BPU" }) }
            </a>
          </div>
        : <a className='small flex-end text-pointer' onClick={ addProduct }>
            <FontAwesomeIcon icon='plus-circle' className="mr-2"/>
            { I18n.t("interventions.add_product") }
          </a>
      }
    </>
  )
}